import {
  DATADOG_WEB_RUM_APPLICATION_ID,
  DATADOG_WEB_RUM_CLIENT_TOKEN,
  DATADOG_SITE,
  DATADOG_WEB_SERVICE_NAME,
  DATADOG_DESKTOP_RUM_APPLICATION_ID,
  DATADOG_DESKTOP_RUM_CLIENT_TOKEN,
  DATADOG_DESKTOP_SERVICE_NAME,
} from "@/domains/datadog/constants";
import { getBackendAnalyticsBaseUrl } from "@/manager/backend-api-client/initializeBackendApiManager";
import { clientEnvModule } from "@/modules/client-env";
import { datadogRum, SessionPersistence } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

const resolveDatadogRumConfig = (): {
  service: string;
  applicationId: string;
  clientToken: string;
  sessionPersistence: SessionPersistence | undefined;
} => {
  if (clientEnvModule.isDesktop()) {
    // Required for Electron.
    return {
      service: DATADOG_DESKTOP_SERVICE_NAME,
      applicationId: DATADOG_DESKTOP_RUM_APPLICATION_ID,
      clientToken: DATADOG_DESKTOP_RUM_CLIENT_TOKEN,
      sessionPersistence: "local-storage",
    };
  }
  return {
    service: DATADOG_WEB_SERVICE_NAME,
    applicationId: DATADOG_WEB_RUM_APPLICATION_ID,
    clientToken: DATADOG_WEB_RUM_CLIENT_TOKEN,
    sessionPersistence: undefined,
  };
};

export const initializeDatadogRumClient = async () => {
  const nodeEnv = clientEnvModule.nodeEnv();
  const packageVersion = clientEnvModule.packageVersion();
  const { buildInfo } = clientEnvModule.buildInfo();
  const version = `${packageVersion}-${buildInfo.gitCommitSha}`;

  const { sessionPersistence, applicationId, clientToken, service } = resolveDatadogRumConfig();

  datadogRum.init({
    applicationId,
    clientToken,
    service,
    env: nodeEnv,
    site: DATADOG_SITE,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    telemetrySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    sessionPersistence,
    defaultPrivacyLevel: "allow",
    plugins: [reactPlugin({ router: true })],
    proxy: `${getBackendAnalyticsBaseUrl()}/v2/analytics/datadog/proxy`,
  });

  datadogRum.setGlobalContextProperty("platform", clientEnvModule.isDesktop() ? "desktop" : "web");
  datadogRum.setGlobalContextProperty("app_version", packageVersion);
  datadogRum.setGlobalContextProperty("operating_system", navigator.userAgent);

  return datadogRum;
};
